module.exports = __webpack_public_path__ + "static/media/TitlesGoodOptimized.2b30c5ea.webp";